export default "__VITE_ASSET__Cuo2sTtX__"